<div mat-dialog-content>
    <div class="profile-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-genProfileNew (closeDialog)="onClose()" [profileId]="profileId"></app-genProfileNew>
</div>